import { Injectable } from "@angular/core";
import { BackendService } from "src/app/services/common/backend.service";

@Injectable({
  providedIn: 'root'
})
export class GetGiftWithColleagueService {
  private readonly apiPath: string = "/api/vendor/invitation/my_invitation_link";

  constructor(
    private backendService:BackendService,
  ) {}

  public async getUniqueLinkForInvitation(): Promise<string> {
    const response: { invitationLink: string } = await this.backendService.callApi(this.apiPath, "GET");
    return response.invitationLink;
  }
}
